<button class="close" mat-button (click)="onNoClick()">X</button>
<h2>Resumen de Intentos</h2>
<table mat-table [dataSource]="dataSource" class="table-resumen">
    <ng-container matColumnDef="intento"> 
        <th mat-header-cell *matHeaderCellDef> INTENTO </th>
        <td mat-cell *matCellDef="let element">{{element.intento}}</td>
    </ng-container>
    <ng-container matColumnDef="estado"> 
        <th mat-header-cell *matHeaderCellDef> ESTADO </th>
        <td mat-cell *matCellDef="let element"> {{element.estado}} </td>
    </ng-container>    
    <ng-container matColumnDef="correctas"> 
        <th mat-header-cell *matHeaderCellDef> CANTIDAD DE RESPUESTAS CORRECTAS </th>
        <td mat-cell *matCellDef="let element"> {{element.correctas}} </td>
    </ng-container>    
    <ng-container matColumnDef="cantidad"> 
        <th mat-header-cell *matHeaderCellDef> CANTIDAD TOTAL DE PREGUNTAS </th>
        <td mat-cell *matCellDef="let element"> {{element.cantidad}} </td>
    </ng-container>    
    <ng-container matColumnDef="porcentaje"> 
        <th mat-header-cell *matHeaderCellDef> PORCENTAJE DE RESPUESTAS CORRECTAS </th>
        <td mat-cell *matCellDef="let element"> {{element.porcentaje}}% </td>
    </ng-container>    
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr> 
</table>